import { measureActions } from "../actions";

const { FETCHING_MEASURES, FETCH_MEASURES_ERROR, FETCH_MEASURES } = measureActions

const initialState = {
	items: [],
	fetching: false,
	error: ''
}

const measures = (state = initialState, action = '') => {
	switch (action.type) {
    case FETCH_MEASURES:
      return {
        ...state,
        items: action.items,
        fetching: false,
        error: ''
      }
    case FETCHING_MEASURES:
      return {
        ...state,
        items: [],
        fetching: true,
        error: ''
      }
    case FETCH_MEASURES_ERROR:
      return {
        ...state,
        items: [],
        fetching: false,
        error: action.error
      }
    default:
      return state
  }
}

export default measures



// WEBPACK FOOTER //
// ./src/reducers/measure.js